import { ActionType } from 'redux-promise-middleware'

export const suffix = {
  fetching: `_${ActionType.Pending}`,
  fetched: `_${ActionType.Fulfilled}`,
  rejected: `_${ActionType.Rejected}`,
  entity: 'ENTITY',
  update: 'UPDATE_ENTITY',
  create: 'CREATE_ENTITY',
  saving: 'SAVING',
  saved: 'SAVED',
  deleting: 'DELETING',
  deleted: 'DELETED',
  restoring: 'RESTORING',
  restored: 'RESTORED',
  refresh: 'REFRESH',
  error: 'ERROR'
}